<div class="header" *ngIf="globals.tokenDataLoaded()" [ngClass]="validateEnvironment()">
	<div class="p-grid">
		<user-config class="p-col-10"></user-config>
		<app-nav class="p-col-2" *ngIf="globals.user.hasAccess"></app-nav>
	</div>
</div>
<hr>
